/**
 * CMSD dynamic header name.
 *
 * @group CMSD
 *
 * @beta
 */
export const CMSD_DYNAMIC = 'CMSD-Dynamic';
//# sourceMappingURL=CMSD_DYNAMIC.js.map